import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Button from '../../../components/common/Button/Button'
import { CModal } from '@coreui/react-pro'
import DragonImage from '../../../assets/dragon_icon.jpeg'
import { setTurnDragonOff } from '../../../redux/progressNote/progressNoteSlice'
import FEATURES from '../../../utils/featuresConstants'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'
import { postFusion } from '../../../apiHelper/fusionApi'

window.NUSA_configure = function () {
  window.NUSA_userId = window.userName || 'claimocitytest'
  window.NUSA_applicationName = window.practiceName || 'Claimocity'
  window.NUSA_enableAll = false
}

export default function DragonController() {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user?.user)
  const turnDragonOff = useSelector((state) => state.progressNote?.turnDragonOff)
  const practice = useSelector((state) => state?.user?.practice)
  const settings = useSelector((state) => state?.user?.settings)
  const features = useSelector((state) => state?.user?.features)

  const canSeeDragon = features?.includes(FEATURES.Dragon)
  const canUseDragon = settings?.canUseDragon
  const [dragonMicOn, setDragonMicOn] = useState(canUseDragon)

  const isAiUrl = getIsAi()

  const [showTermsModal, setShowTermsModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let timer = null
    if (canSeeDragon && dragonMicOn) {
      timer = setTimeout(() => {
        try {
          if (window.NUSA_initializeVuiForm) {
            // show/render microphone if enabled/active
            window.NUSA_initializeVuiForm()
          } else {
            // not loaded, load Dragon
            window.userName = user.displayname || ''
            window.practiceName = practice?.organization_name || ''
            document.cookie = `NUSA_Guids=${
              user?.isInternal
                ? '9d544bb6-7d19-444a-94a2-d8aa4703b7d0'
                : '1950d66f-b30a-4f86-bd02-9af6bf3d0e47'
            }/bb1db3cd-9a2a-4453-9d74-33047c53b89a`
            window.loadjs(
              'https://speechanywhere.nuancehdp.com/mainline/scripts/Nuance.SpeechAnywhere.js',
            )
          }
        } catch (e) {
          console.error(e)
        }
      }, 2000)
    }
    return () => {
      if (window.NUSA_closeVuiForm) {
        // hide Dragon when component unmounts
        window.NUSA_closeVuiForm()
      }
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [canSeeDragon, dragonMicOn])

  useEffect(() => {
    if (turnDragonOff) {
      setDragonMicOn(false)
      dispatch(setTurnDragonOff(false))
    }
  }, [dispatch, turnDragonOff])

  return (
    <div className={isAiUrl ? 'panel-dragon-dictation' : 'dragon-dictation-info'}>
      {!isAiUrl && (
        <div>
          Voice dictation <div>{Boolean(dragonMicOn) ? 'ENABLED' : 'DISABLED'}</div>
        </div>
      )}
      <button
        style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
        onClick={() => {
          if (dragonMicOn) {
            setDragonMicOn(false)
          } else if (canUseDragon) {
            setDragonMicOn(true)
          } else {
            setShowTermsModal(true)
          }
        }}
      >
        <img
          src={DragonImage}
          alt="Dragon Speech Icon"
          style={{
            height: isAiUrl ? '2em' : '3em',
            width: isAiUrl ? '3em' : '4em',
            ...(isAiUrl
              ? !dragonMicOn
                ? {
                    filter: 'grayscale(100%) opacity(35%)',
                  }
                : { border: '2px solid var(--green_600)' }
              : {}),
          }}
        />
      </button>

      <CModal
        alignment="center"
        className={'nuanceTOS'}
        backdrop={true}
        keyboard={false}
        portal={false}
        visible={showTermsModal}
        size="lg"
        fullscreen="lg"
        onClose={() => setShowTermsModal(false)}
      >
        <div className="inner-modal" style={{ padding: '0 24px' }}>
          <div className="modal-header" style={{ paddingLeft: '0', paddingRight: 0 }}>
            <span onClick={() => setShowTermsModal(false)}>
              Subscribe to Dragon Voice Dictation?
            </span>
            <i
              className="far fa-xmark"
              style={{ fontSize: '1.1em', cursor: 'pointer' }}
              onClick={() => setShowTermsModal(false)}
            ></i>
          </div>
          <br />

          <div className="modal-body" style={{ padding: '0 24px 24px' }}>
            <div className="modal-text">
              By selecting &apos;Accept&apos;, you are agreeing to enable Dragon medical voice
              dictation by Nuance withing the Claimocity desktop. This includes accepting the
              $99/month fee for using the Dragon voice dictation software in Claimocity (invoiced
              monthly).
            </div>
            <div className="modal-text">
              By accepting, you are also agreeing to Nuance&apos;s terms of service, which can be
              found{' '}
              <a
                target={'_blank'}
                href={
                  'https://www.nuance.com/dragon/dragon-anywhere/eula.html?srsltid=AfmBOopukao1ylsd-laTlNFAfs5HZ2TH-DGJwsQgdSoDUIr0r4koYZsu'
                }
                rel="noreferrer"
              >
                here.
              </a>
            </div>
          </div>

          <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
            <Button onClick={() => setShowTermsModal(false)}>Cancel</Button>
            <Button
              color="primary"
              onClick={async () => {
                if (isLoading) {
                  return
                }
                setIsLoading(true)
                const res = await postFusion(
                  '/v1/stripe/create_checkout_session' +
                    (window.location.host.includes('stage') ? '_test' : ''),
                )
                setIsLoading(false)
                setShowTermsModal(false)
                localStorage.setItem('dragonInfo', JSON.stringify(res))
                window.open(res.url, '_blank')
              }}
            >
              {isLoading ? (
                <i className="fa-duotone fa-solid fa-spinner-third fa-spin"></i>
              ) : (
                'Agree'
              )}
            </Button>
          </div>
        </div>
      </CModal>
    </div>
  )
}
